import dayjs from 'dayjs';
import { currencyFormatter, getInvoiceStatus } from '../../../utils/utils';

export const normalizeInvoiceData = (data) => {
  const dataSource = data.map((item, index) => {
    const { statusLabel, statusColor } = getInvoiceStatus({
      oper_facturado: item.oper_facturado,
      efact_descripcion: item.efact_descripcion,
      errtim_descripcion: item.errtim_descripcion
    });
    return {
      key: `${item.oper_id}_${index}`,
      oper_id: item.oper_id,
      oper_clie_id: item.oper_clie_id,
      'Número de operación': item.oper_id,
      'Fecha de operación': dayjs(item.oper_fecha).format('DD-MM-YYYY'),
      Tipo: item.oper_tipo_operacion === 1 ? 'Boletaje' : 'Pensiones',
      Total: currencyFormatter(item.oper_total),
      RFC: item.clie_rfc,
      Procedencia: item.oper_sistema === null ? '-' : item.oper_sistema === 1 ? 'Internet' : 'Sistema',
      'Forma Pago': item.forma_pago,
      'Método Pago': item.metodo_pago,
      status: item.oper_facturado,
      efact_descripcion: item.efact_descripcion,
      errtim_descripcion: item.errtim_descripcion,
      estado: statusLabel,
      estado_color: statusColor
    };
  });
  const columns = Object.keys(dataSource[0] || {})
    .map((key) => {
      const hiddenColumns = [
        'key',
        'oper_id',
        'efact_descripcion',
        'errtim_descripcion',
        'status',
        'estado',
        'estado_color',
        'oper_clie_id'
      ];
      if (!hiddenColumns.includes(key)) {
        return { title: key, dataIndex: key, key, className: 'col-' + key.replaceAll(' ', '_').toLowerCase() };
      }
      return null;
    })
    .filter((col) => col !== null);

  return { dataSource, columns };
};
export const normalizeInvoiceDataForExport = (data) => {
  return data.map((item) => {
    const { statusLabel } = getInvoiceStatus({
      oper_facturado: item.oper_facturado,
      efact_descripcion: item.efact_descripcion,
      errtim_descripcion: item.errtim_descripcion
    });
    return {
      'Número de operación': item.oper_id,
      'Fecha de operación': dayjs(item.oper_fecha).format('DD-MM-YYYY'),
      Tipo: item.oper_tipo_operacion === 1 ? 'Boletaje' : 'Pensiones',
      Total: currencyFormatter(item.oper_total),
      RFC: item.clie_rfc,
      Procedencia: item.oper_sistema === null ? '-' : item.oper_sistema === 1 ? 'Internet' : 'Sistema',
      Estado: statusLabel,
      'Descripción del estado': item.errtim_descripcion
    };
  });
};
